import { call, put, all, takeLatest } from 'redux-saga/effects';
import moment from 'moment';

import { apiTransacao } from '~/services/api';
import {
	successTransacoes,
	failureTransacoes,
	successTransacoesOntem,
	failureTransacoesOntem,
	successTransacoes30Dias,
	failureTransacoes30Dias,
	successBandeiras,
	failureBandeiras,
	successTopDiasVendas,
	failureTopDiasVendas,
	successModalidade,
	failureModalidade,
	successRecebimentos,
	failureRecebimentos,
	successGraficoEvolutivo,
	failureGraficoEvolutivo,
} from './actions';

function orderDateMatched(dateA, dateB) {
	return moment(dateA.fullDateMatched) - moment(dateB.fullDateMatched);
}

function* requestTransacoes({ payload }) {
	const { idCliente } = payload;

	// yield delay(3000);
	try {
		const resposta = yield call(apiTransacao.post, `transacoes_cliente/`, {
			idUsu: idCliente,
			filters: {
				dateInit: moment().format('YYYY-MM-DD'),
				dateEnd: moment().format('YYYY-MM-DD'),
			},
			orderBy: [{ name: 'payment_date' }],
			page: 1,
			perPage: 0,
		});
		yield put(successTransacoes(resposta.data));
	} catch (error) {
		yield put(failureTransacoes(error.response.status));
	}
}

function* requestTransacoesOntem({ payload }) {
	const { idCliente } = payload;
	// yield delay(500);
	try {
		const resposta = yield call(apiTransacao.post, `transacoes_cliente/`, {
			idUsu: idCliente,
			filters: {
				dateInit: moment().subtract(1, 'days').format('YYYY-MM-DD'),
				dateEnd: moment().subtract(1, 'days').format('YYYY-MM-DD'),
			},
			orderBy: [{ name: 'payment_date' }],
			page: 1,
			perPage: 10,
		});
		yield put(successTransacoesOntem(resposta.data));
	} catch (error) {
		yield put(failureTransacoesOntem(error.response.status));
	}
}

function* requestTransacoes30Dias({ payload }) {
	const { idCliente } = payload;
	// yield delay(1000);
	try {
		const resposta = yield call(apiTransacao.post, `transacoes_cliente/`, {
			idUsu: idCliente,
			filters: {
				dateInit: moment().subtract(30, 'days').format('YYYY-MM-DD'),
				dateEnd: moment().format('YYYY-MM-DD'),
			},
			orderBy: [{ name: 'payment_date' }],
			page: 1,
			perPage: 10,
		});
		yield put(successTransacoes30Dias(resposta.data));
	} catch (error) {
		yield put(failureTransacoes30Dias(error.response.status));
	}
}

function* requestBandeiras({ payload }) {
	const { params } = payload;
	// yield delay(1500);
	try {
		const resposta = yield call(
			apiTransacao.get,
			`qtd-transacoes-bandeira/${params}`
		);
		yield put(successBandeiras(resposta.data));
	} catch (error) {
		yield put(failureBandeiras(error.response.status));
	}
}

function* requestTopDiasVendas({ payload }) {
	const { params } = payload;
	// yield delay(2000);
	try {
		const resposta = yield call(
			apiTransacao.get,
			`top-dias-transacoes/${params}`
		);
		yield put(successTopDiasVendas(resposta.data));
	} catch (error) {
		yield put(failureTopDiasVendas(error.response.status));
	}
}

function* requestModalidade({ payload }) {
	const { params } = payload;
	// yield delay(2500);
	try {
		const resposta = yield call(
			apiTransacao.get,
			`qtd-transacoes-modalidade/${params}`
		);

		yield put(successModalidade(resposta.data.data));
	} catch (error) {
		yield put(failureModalidade(error.response.status));
	}
}

function* requestRecebimentos({ payload }) {
	const { params } = payload;
	// yield delay(2500);
	try {
		const resposta = yield call(
			apiTransacao.get,
			`recebimentos-cliente/${params}/cards?init_date=${moment()
				.add(-4, 'days')
				.format('YYYY-MM-DD')}&end_date=${moment()
					.add(4, 'days')
					.format('YYYY-MM-DD')}`
		);

		const arrayLista = [];

		Object.keys(resposta.data).forEach((item) => {
			arrayLista.push(resposta.data[item]);
		});

		yield put(successRecebimentos(arrayLista));
	} catch (error) {
		yield put(failureRecebimentos(error.response.status));
	}
}

function* requestGraficoEvolutivo({ payload }) {
	const { params } = payload;
	// yield delay(2500);
	try {
		const resposta = yield call(apiTransacao.post, `transacoes_cliente/`, {
			idUsu: params,
			filters: {
				dateInit: moment().subtract(30, 'days').format('YYYY-MM-DD'),
				dateEnd: moment().format('YYYY-MM-DD'),
			},
			orderBy: [{ name: 'payment_date' }],
			page: 1,
			perPage: 10,
		});

		const compareList = resposta.data.data;
		const exportList = [];
		let newList = [];
		let groupDate = null;
		const groupArray = [];

		// Função que agrupa as vendas por dia
		for (let i = 0; i < resposta.data.data.length; i += 1) {
			groupDate = compareList.filter(
				(item) =>
					moment(item.payment_date).format('DD-MM-YYYY') ===
					moment(resposta.data.data[i].payment_date).format(
						'DD-MM-YYYY'
					)
			);

			groupArray.push({
				dateMatched: moment(resposta.data.data[i].payment_date).format(
					'DD/MM/YYYY'
				),
				fullDateMatched: resposta.data.data[i].payment_date,
				list: groupDate,
			});
		}

		// Função que remove os agrupamentos repetidos
		newList = groupArray.filter(
			(group, index, self) =>
				index ===
				self.findIndex(
					(found) => found.dateMatched === group.dateMatched
				)
		);

		newList.forEach((item) => {
			let valorTotal = 0;
			for (let i = 0; i < item.list.length; i += 1) {
				valorTotal += item.list[i].value;
			}
			exportList.push({
				...item,
				valorTotal,
			});
		});

		yield put(successGraficoEvolutivo(exportList.sort(orderDateMatched)));
	} catch (error) {
		yield put(failureGraficoEvolutivo(error.response.status));
	}
}

export default all([
	takeLatest('@clientDash/REQUEST_TRANSACOES', requestTransacoes),
	takeLatest('@clientDash/REQUEST_TRANSACOES_ONTEM', requestTransacoesOntem),
	takeLatest(
		'@clientDash/REQUEST_TRANSACOES_30_DIAS',
		requestTransacoes30Dias
	),
	takeLatest('@clientDash/REQUEST_BANDEIRAS', requestBandeiras),
	takeLatest('@clientDash/REQUEST_TOP_DIAS_VENDAS', requestTopDiasVendas),
	takeLatest('@clientDash/REQUEST_MODALIDADE', requestModalidade),
	takeLatest('@clientDash/REQUEST_RECEBIMENTOS', requestRecebimentos),
	takeLatest(
		'@clientDash/REQUEST_GRAFICO_EVOLUTIVO',
		requestGraficoEvolutivo
	),
]);
